import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  TopicsListRequest,
  DeleteTopicsRequest,
  SetTopicsVisibilityRequest,
  PostsListRequest,
  PostResponse,
  DeletePostsRequest,
  TopicResponse,
} from "../types/api/forum";

const path = `/forum/admin/${process.env.REACT_APP_API_VERSION}`;

// Топики (темы) форума - Получить список
export function fetchTopics(params: TopicsListRequest) {
  return mainAPI.get<TopicResponse[]>(`${path}/topics`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Топики (темы) форума - Удалить
export function deleteTopics(data: DeleteTopicsRequest) {
  return mainAPI.post(`${path}/topics/delete`, { ids: data.ids }).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}

// Топики (темы) форума - Скрыть или показать
export function setTopicsVisibility(data: SetTopicsVisibilityRequest) {
  return mainAPI
    .post(`${path}/topics/visibility`, { ids: data.ids, isHidden: data.isHidden })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => handleApiError(error)
    );
}

// Посты (комментарии) форума - Получить список
export function fetchPosts(params: PostsListRequest) {
  return mainAPI.get<PostResponse[]>(`${path}/posts`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Посты (комментарии) форума - Удалить
export function deletePosts(data: DeletePostsRequest) {
  return mainAPI.post(`${path}/posts/delete`, { ids: data.ids }).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}

// Тема форума - Получить запись
export function fetchTopic(id: string) {
  const url = `/forum/${process.env.REACT_APP_API_VERSION}/topics`;
  return mainAPI.get(`${url}/${id}`).then(
    (res) => {
      return Promise.resolve(res.data as TopicResponse);
    },
    (error) => handleApiError(error)
  );
}
// Пост - Получить запись
export function fetchPost(id: string) {
  const url = `/forum/${process.env.REACT_APP_API_VERSION}/posts`;
  return mainAPI.get(`${url}/${id}`).then(
    (res) => {
      return Promise.resolve(res.data as PostResponse);
    },
    (error) => handleApiError(error)
  );
}

// Посты (комментарии) форума - Экспортировать
export function exportPosts() {
  return mainAPI.get(`${path}/posts/export`, { responseType: "blob" }).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(
        new Error(apiError?.detail || "Ошибка при экспорте комментариев")
      );
    }
  );
}
